import React, {  Component } from 'react';
import { connect } from 'react-redux';

import moment from 'moment';

/* Actions */
import {
	getGeDistributorData,
	saveGeDistributorData
} from '../../../redux/actions';


class GeDistributor extends Component {

	constructor(props) {
		super(props);
		this.state = {
			errorMessage: '',
			geDistributorData: null,
			monogramBase: ['1.00%','2.00%','3.00%','4.00%','5.00%']
		}
	}

	componentDidMount() {
		const self = this;
		const { geDistributorData } = self.props.state.resources;
		let dataByAccountNumber = geDistributorData && geDistributorData.find(item => item.accountNumber === self.props.getSelectedAccountNumber());
		dataByAccountNumber = dataByAccountNumber && dataByAccountNumber.data;
		if(!dataByAccountNumber) {
			self.props.getGeDistributorData("requestType=gedlr&accountNumber="+self.props.getSelectedAccountNumber()+"&year=2026", response => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					});
				} else {
					self.props.saveGeDistributorData({
						accountNumber: self.props.getSelectedAccountNumber(),
						data: response
					});
					let data = JSON.parse(JSON.stringify(response.responseObject));
					data.mvrMatrix = window.convertToArrayOfObject(data.mvrMatrix, 'groupBy');
					self.setState({
						geDistributorData: data
					});
				}
			});
		} else {
			const data = JSON.parse(JSON.stringify(dataByAccountNumber.responseObject));
			data.mvrMatrix = window.convertToArrayOfObject(data.mvrMatrix, 'groupBy');
			self.setState({
				geDistributorData: data
			});
		}
		const { user } = this.props.state;
        if(user.selectedAccount && user.selectedPriceSource) {
            this.setState({
                showSelectAccountAndPriceSourceOverlayDialog: false
            });
        } else {
            this.setState({
                showSelectAccountAndPriceSourceOverlayDialog: true
            });
        }
	}

	checkIfHighlight(mnMatSelect, valueToCompare, index) {
		if(mnMatSelect) {
			if((index === 0 && mnMatSelect.split("_")[index] === valueToCompare) || (index === 1 && mnMatSelect === valueToCompare))  {
				return 'highlight-cell';
			}
		}
		return null;
	}

    render() {
		const { geDistributorData } = this.state;
		const self = this;
		const { selectedAccount } = self.props.state.user;
		if(geDistributorData) {
			var sortedArray = geDistributorData.mvrMatrix.sort(function(a,b){
				return a.list >b.list?1:a.list <b.list?-1:0
		 	});
		}
		const targetGSB = geDistributorData && Math.round(geDistributorData.targetGSB);
        const priorYearGSB = geDistributorData && Math.round(geDistributorData.priorYearGSB);
		const estimatedGe1 = geDistributorData ? (geDistributorData.gePayout * (geDistributorData.payOnBrandRateGeHaier / 100))  :'';
		const estimatedGe2 = geDistributorData? (geDistributorData.cafeProfilePayout * (geDistributorData.payOnBrandRateCafeProfile / 100)) :"";
		const estimatedGe3 = geDistributorData ? (parseFloat(estimatedGe1) + parseFloat(estimatedGe2)) : "";
        return (
			<div>
				<p className="red bold">{this.state.errorMessage}</p>
				{geDistributorData && geDistributorData.dataAvailable && <p style={{float: 'right', display: 'inline-block'}}>
					<a href="" onClick={this.props.handlePrint} className="withIcon withPrintIcon noUnderline uppercase bold">Print</a>
				</p>}
				<h1 className="pageTitle" style={{margin: '2em 0 1em'}}>100% GE Appliances Distributor PIF</h1>
				{geDistributorData && !geDistributorData.dataAvailable && <p>No 100% GE Appliances Distributor PIF available for this account.</p>}
				{geDistributorData && geDistributorData.dataAvailable && <div>
					<b>Account:</b> {selectedAccount && selectedAccount.ACCOUNTNUMBER}&nbsp;<b>-</b>&nbsp;{selectedAccount && selectedAccount.ACCOUNTDESCRIPTION}<br />
			        <h2>Today&#39;s Date: {moment().format('MMMM DD, YYYY')}</h2>
				    <p className="orange" style={{marginTop: '-14px'}}>(Billing Date: {geDistributorData.maxBillingDate})</p>
			        <p style={{marginBottom: 20}}>The information in this screen is provided to distributors who only display and sell GE Appliances brands. Information is updated weekly.</p>
					<ul style={{marginBottom: 20}}>
					<li>Customer must maintain $150,000 annual total GSB minimum to qualify.</li>
					<li>Quote Volume, Hotpoint, Monogram, RAC, Water Heaters, Coin-Op, Homeownership, 
						AS-IS, Superseded, Obsolete, Net/Net, and Accessories count toward volume classification, 
						but do not accrue VR dollars.</li>
					<li>The VR will be paid annually based upon verification by ASM that display is current. 
						The 100% GE Appliances ABD program is a year-long program.</li>
					<li>The VR will be paid on all Café, GE Profile Series, GE, Haier models less above listed exclusions.</li>
					</ul>
			        <h2>Total GSB</h2>
					<table cellPadding={0} cellSpacing={0} className="pvrTableOne push">
						<tbody>
							<tr>
								<th className="txt-ctr">Prior Year<br />Total GSB</th>
								<th className="txt-ctr">Current Year<br />Total GSB</th>
							</tr>
							<tr>
								<td className="txt-ctr">{this.props.formatMoney(priorYearGSB.toFixed(0), 0, ".", ",", true, "$")}</td>
								<td className="txt-ctr">{this.props.formatMoney(targetGSB.toFixed(0), 0, ".", ",", true, "$")}</td>
							</tr>
						</tbody>
					</table>
			        <h2>Current PIF YTD AS OF {geDistributorData.maxBillingDate}</h2>
			        <div>
						<table className="dataTable" width="100%">
						<thead>
							<tr>
							<th className="txt-ctr" colSpan={3} style={{ border: "1px solid #bbb", padding: "6px" }}>GE/HAIER</th>
							<th className="txt-ctr" colSpan={3} style={{ border: "1px solid #bbb", padding: "6px" }}>PROFILE/CAFE</th>
							<th className="txt-ctr" style={{ border: "1px solid #bbb", padding: "6px" }}>GE/HAIER/<br/>PROFILE/CAFE</th>
							</tr>
							<tr>
							<th style={{ border: "1px solid #bbb", padding: "6px", textAlign:"center" }}>QUALIFYING<br/> %</th>
							<th style={{ border: "1px solid #bbb", padding: "6px", textAlign:"center" }}>ELIGIBLE<br/> GSB</th>
							<th style={{ border: "1px solid #bbb", padding: "6px", textAlign:"center" }}>ESTIMATED<br/>PAYMENT</th>
							<th style={{ border: "1px solid #bbb", padding: "6px", textAlign:"center" }}>QUALIFYING<br/> %</th>
							<th style={{ border: "1px solid #bbb", padding: "6px", textAlign:"center" }}>ELIGIBLE<br/> GSB</th>
							<th style={{ border: "1px solid #bbb", padding: "6px", textAlign:"center" }}>ESTIMATED<br/>PAYMENT</th>
							<th style={{ border: "1px solid #bbb", padding: "6px", textAlign:"center" }}>ESTIMATED<br/>TOTAL PAYOUT</th>
							</tr>
						</thead>

						<tbody>
							<tr>
							<td style={{ padding: "6px", textAlign: "center", border: "1px solid #bbb" }}>
								{`${Number(geDistributorData.payOnBrandRateGeHaier).toFixed(2)}%`}
							</td>
							<td style={{ padding: "6px", textAlign: "center", border: "1px solid #bbb" }}>
								{this.props.formatMoney(geDistributorData.gePayout.toFixed(0), 0, ".", ",", true, "$")}
							</td>
							<td style={{ padding: "6px", textAlign: "center", border: "1px solid #bbb" }}>
								{this.props.formatMoney(estimatedGe1.toFixed(0), 0, ".", ",", true, "$")}
							</td>

							<td style={{ padding: "6px", textAlign: "center", border: "1px solid #bbb" }}>
								{`${Number(geDistributorData.payOnBrandRateCafeProfile).toFixed(2)}%`}
							</td>
							<td style={{ padding: "6px", textAlign: "center", border: "1px solid #bbb" }}>
								{this.props.formatMoney(geDistributorData.cafeProfilePayout.toFixed(0), 0, ".", ",", true, "$")}
							</td>
							<td style={{ padding: "6px", textAlign: "center", border: "1px solid #bbb" }}>
								{this.props.formatMoney(estimatedGe2.toFixed(0), 0, ".", ",", true, "$")}
							</td>
							<td style={{ padding: "6px", textAlign: "center" }}>
								{this.props.formatMoney(estimatedGe3.toFixed(0), 0, ".", ",", true, "$")}
							</td>
							</tr>
						</tbody>
						</table>
			        </div>
			        <div style={{width:'100%', textAlign:'center', captionSide:'unset',paddingTop:"5px"}}>
						<table className="dataTable" width="100%">
							<thead>
								<tr>
								<th className="txt-ctr" style={{ border: "1px solid #bbb", padding: "6px" }}>
									Qualifying Purchases<br/>(GSB$)
								</th>
								<th className="txt-ctr" style={{ border: "1px solid #bbb", padding: "6px" }}>
									GE &amp; Haier Series Eligible<br/>Payout %
								</th>
								<th className="txt-ctr" style={{ border: "1px solid #bbb", padding: "6px" }}>
									Café &amp; GE Profile Series Eligible<br/>Payout %
								</th>
								</tr>
							</thead>

							<tbody>
								<tr>
								<td style={{ border: "1px solid #bbb", padding: "6px", textAlign:"center" }}>
									$150M to $500M
								</td>
								<td style={{ border: "1px solid #bbb", padding: "6px", textAlign:"center" }}>
									3.00%
								</td>
								<td style={{ border: "1px solid #bbb", padding: "6px", textAlign:"center" }}>
									4.00%
								</td>
								</tr>
								<tr>
								<td style={{ border: "1px solid #bbb", padding: "6px", textAlign:"center" }}>
									{`>$500M`}
								</td>
								<td style={{ border: "1px solid #bbb", padding: "6px", textAlign:"center" }}>
									4.25%
								</td>
								<td style={{ border: "1px solid #bbb", padding: "6px", textAlign:"center" }}>
									5.25%
								</td>
								</tr>
							</tbody>
							</table>
			        </div>
				</div>}
			</div>
        );
    }
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getGeDistributorData: (queryString, callback) => dispatch(getGeDistributorData(queryString, callback)),
	saveGeDistributorData: (data) => dispatch(saveGeDistributorData(data)),
});

GeDistributor = connect(mapStateToProps, mapDispatchToProps)(GeDistributor);
export default GeDistributor;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/GeDistributor/index.js